export const NCLT_API_BASE_URL = "https://jncltt.valscotech.com";
